import AppService from "./app-service"

export default class VetService extends AppService {

  constructor() {
    super({ path: "vets" })
  }

  checkVetName(name, id) {
    return this.http.post("check-vet-name", { name, id })
  }
}